import { render } from "./ManageRealtime.vue?vue&type=template&id=6d1fc096"
import script from "./ManageRealtime.vue?vue&type=script&lang=js"
export * from "./ManageRealtime.vue?vue&type=script&lang=js"

import "./ManageRealtime.vue?vue&type=style&index=0&id=6d1fc096&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__